export const configKeys = {
  allConfigs: ['all-configs'],
  config: ['config'],
  projectConfig: (slug: string) => [...configKeys.config, slug],
};
